import { req } from '../@api/request';

export default class BondSerivce {
  static Register = async (data: any) => {
    const result = await req.post('/bond/register', data);
    return result.data;
  };
  static list = async (
    bond_category: string,
    region: string,
    item_category: string,
    search: string,
    sort: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/bond/list?bond_category=${bond_category}&region=${region}&item_category=${item_category}&search=${search}&sort=${sort}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static register = async (data: any) => {
    const result = await req.post('/bond/register', data);
    return result.data;
  };
  static detail = async (b_idx: string) => {
    const result = await req.get(`/bond/detail?b_idx=${b_idx}`);
    return result.data;
  };
  static delete = async (b_idx: string) => {
    const result = await req.patch(`/bond/delete`, { b_idx: b_idx });
    return result.data;
  };
  static status = async () => {
    const result = await req.get(`/bond/stat`);
    return result.data;
  };
  static update = async (data: any) => {
    const result = await req.patch('/bond/update', data);
    return result.data;
  };
}
